import React, {Component} from 'react'
import { connect } from 'react-redux'


class StudySetContainer extends Component {
	render() {
	
		return (
  			<div className='reportPackBuilderContainer'>
  				<div className='reportPackBuilder'> 
  					Revision Set Maker				
				</div>
				<div className='reportPackBuilderOverlay' onClick={this.props.closeStudySetModal}/>
			</div>
    
		)
	}
}


export default connect(
	(state,ownProps) => ({
		//notification: state.notification,
	}),
	{ 
	})(StudySetContainer)

